





















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AgroResponsiveTable from "@/components/agroResponsiveTable/AgroResponsiveTable.vue";
import * as services from "@/services/results";
import i18n from "@/i18n";
import { HarvestResultTableDTO } from "@/api/results/types";
import { differenceInDays } from "date-fns";
import { roundedWithFrac } from "@/filters/scalar";
import { formattedYield, formattedProduction } from "@/filters/yield";
import { Analysis } from "@/api/analyses/types";

@Component({
  name: "HarvestResultTableController",
  components: {
    AgroResponsiveTable,
  },
  filters: {
    roundedWithFrac,
    formattedYield, 
    formattedProduction,
    formattedDate(value: Date) {
      if (!value) {
        return "";
      } else {
        const dateAux = new Date(value);
        dateAux.setUTCMinutes(
          dateAux.getUTCMinutes() + dateAux.getTimezoneOffset()
        );
        return i18n.d(dateAux, "short");
      }
    },
  },
})
export default class HarvestResultTableController extends Vue {

  @Prop(Object)
  private analysis!: Analysis;

  @Prop({ type: String, required: true })
  private harvestSeason!: string;

  @Prop({ type: String, required: true })
  private cropType!: string;

  private prefix: string = "compare-farms-owners";

  private columnsLabel: object = {};
  private rows: HarvestResultTableDTO[] = [];

  private differenceInDays(finalDate: Date | null, initialDate: Date | null) {
    if (!!finalDate) {
      return differenceInDays(finalDate, initialDate as Date);
    }
    return '';
  }

  get harvestResultItens() {
    return this.$store.state.results.harvestResultContext;
  }

  private tableColumns = [
    { name: "analysis-year" },
    { name: "average-planting-date" },
    { name: "average-harvest-date" },
    { name: "cycle" },
    { name: "average-yield" },
    { name: "production" },
  ];

  private async created() {
    await this.loadTableData();
    this.columnsLabel = {
      analysisYear: i18n.t("compare-farms-owners.analysis-year"),
      averagePlantingDate: i18n.t("compare-farms-owners.average-planting-date"),
      averageHarvestDate: i18n.t("compare-farms-owners.average-harvest-date"),
      cycle: i18n.t("compare-farms-owners.cycle"),
      averageYield: i18n.t("compare-farms-owners.average-yield"),
      production: i18n.t("compare-farms-owners.production"),
    };
  }

  private async loadTableData() {
    this.$emit('update:loading', true);
    const requestKey = this.fetchKey;
    try {
      const rows = await services.getHarvestResult(this.analysis.uuid, this.harvestSeason, this.cropType);
      if (this.fetchKey === requestKey) {
        this.rows = rows;
      }
    } finally {
      this.$emit('update:loading', false);
    }
  }

  get fetchKey() {
    return `${this.harvestSeason}:${this.cropType}`;
  }

  @Watch('fetchKey')
  private async onFetchKeyChange() {
    await this.loadTableData();
  }
}
